<template>
    <div class="booking__panel">
        <p class="booking__headline">{{ dictionary.BookingFlowHelpHeadline }}</p>
        <p class="booking__message">{{ dictionary.BookingFlowHelpText }}</p>
        <br/>
        <p class="booking-help__item">
            <img src="/assets/images/phone.svg" /><a :href="'tel:' + dictionary.BookingFlowHelpPhone">{{ dictionary.BookingFlowHelpPhone }}</a>
        </p>
        <p class="booking-help__item">
            <img src="/assets/images/mail.svg" />
            <a :href="'mailto:' + dictionary.BookingFlowHelpEmail">{{ dictionary.BookingFlowHelpEmail }}</a>
        </p>
        
    </div>
</template>
<script>
export default {
    name: "help",
    data() {
        return {
            dictionary:[]
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetHelpDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
</script>
